import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

interface RMSummarylog{
  rawMaterialName: string;
  inwardQuantity: number;
  outwardQuantity: number;
  adjustQuantity: number;
}

interface SummaryTableProps {
  data: RMSummarylog[];
  loading: boolean;
}

export const RawMaterialMovementSummary = ({ data, loading }: SummaryTableProps) => (
  
  <DataTable
      value={data}
      loading={loading}
      paginator
      rows={10}
      rowsPerPageOptions={[5, 10, 20, 50]}
      paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
      currentPageReportTemplate="{first} to {last} of {totalRecords}"
    >
    <Column field="rawMaterialName" header="RawMaterial" sortable/>
    <Column field="inwardQuantity" header="Inward" sortable/>
    <Column field="outwardQuantity" header="Outward" sortable/>
    <Column field="adjustQuantity" header="Adjust" sortable/>
  </DataTable>
);
